var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterFunnel02 = function SvgFilterFunnel02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.4 12.528 19.111 4H4.887l6.713 8.528V20h.8zm1.5 7.85q0 .48-.322.8a1.09 1.09 0 0 1-.8.322H11.22q-.477 0-.8-.321a1.07 1.07 0 0 1-.316-.683l-.004-.117v-7.331L3.009 4.04q-.366-.487-.107-1.014.26-.526.876-.526h16.443l.148.008a.88.88 0 0 1 .727.518q.26.527-.106 1.014l-7.09 9.008z"
  })));
};
export default SvgFilterFunnel02;